module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Marti_Anna.fc7f922d.jpg";